import { Box, useTheme } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import FontAwesome from 'react-fontawesome';

import Button from '../../././Button';

interface DropzoneClear {
  onClear: MouseEventHandler;
}

const DropzoneClear = ({ onClear }: DropzoneClear): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '& button, & [role="button"]': {
          color: '#707070',
          float: 'right',
          padding: '0.1em',
        },
        paddingRight: '0.5em',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: theme.zIndexFormInputButtons,
      }}
    >
      <Button variant="text" onClick={onClear}>
        <FontAwesome name="times" />
      </Button>
    </Box>
  );
};

export default DropzoneClear;
